import {createActions} from 'client/framework';

const subjectFAQListActions = ['ADD_NEW_FAQ', 'DISCARD_NEW_FAQ'];

export default createActions(null, subjectFAQListActions);
